class PincodeChecker {
  constructor() {
    // Global Variable
    this.uri =
      "https://middleware.doctordreams.com/api/get-pincodecheckerdata-test";
    this.defaultPincode = "400028";

    // Buttons
    this.dummyButtonContainer = $(".dummyClassBox");
    this.realAtcButton = $(".product-buy-buttons--primary");
    this.realBuyButton = $(".product-buy-buttons--smart");
    this.stickyDummyButton = $(".sticky-border-btn.custom_addtocart__button");
    this.stickyRealButton = $(".new_add_btn");
    this.magicChckoutButton = $('magic-checkout-btn[page-type="product"]');

    // DOM Classes
    this.pincodeCheckerInput = $("#pincodeCheckerInput");
    this.pincodeCheckerButton = $("#pincodeCheckerButton");
    this.pincodeCheckerDummyButton = $("#dummyButton");
    this.pincodeCheckerHideClass = "pincodeCheckerHide";
    this.pincodeCheckerFlexClass = "pincodeCheckerFlex";
    this.pincodeCheckerBlockClass = "pincodeCheckerBlock";
    this.errorResponseDiv = $("#pincodeCheckerError");
    this.responsePrintDiv = $("#pincodeCheckerResponse");
    this.errorMessageDiv = $("#pincodeCheckerError > #errorMessage");
    this.responseShippingDiv = $("#pincodeCheckerResponse > .respone_shipping");
    this.responseDateDiv = $("#pincodeCheckerResponse > .response_date");
    this.shakeAnimation = "shake-animation";
    this.shakeAnimationAddClass = $('.input_button_parent');

    // Form Data
    this.payLoadVariantId = $(".pincodeVariantId");
    this.payloadSku = $(".pincodeSku");
    this.payloadSkuQty = $(".pincodeSkuQty");
    this.payloadSkuAvailable = $(".pincodeSkuAvailable");
    this.payloadQtySelect = $(".productQtySelected");

    // Ajax Stop Variable
    this.ajaxStop = false;

    //ADD (ONLY STATE VARIABLE)
    this.lastApiPincode = "";

    // Function Initialize On load
    this.setDefaultPincodeOnLoad();
  }

  /* =========================
      DEFAULT PINCODE (LOCALSTORAGE)
    ========================= */
  setDefaultPincodeOnLoad() {
    const storageKey = "pincode_checker";
    let savedPincode = localStorage.getItem(storageKey);

    if (!savedPincode) {
      localStorage.setItem(storageKey, this.defaultPincode);
      savedPincode = this.defaultPincode;
    }

    if (this.pincodeCheckerInput.length) {
      this.pincodeCheckerInput.val(savedPincode);
    }

    this.bindEventlistner();
    this.changeVariantData();
    this.quantityChange();
    this.apiRunHelper();
  }

  /* =========================
      Run API Function
    ========================= */
  apiRunHelper() {
    const _this = this;
    this.pincodeButtonHelper(true);
    this.pincodeATCButton(false);
    const responseContainer = this.responsePrintDiv;
    const errorConatiner = this.errorResponseDiv;
    const errorMessage = this.errorMessageDiv;

    var form = new FormData();
    form.append("pincode", this.pincodeCheckerInput.val());
    form.append("variant_id", this.payLoadVariantId.val());
    form.append("sku", this.payloadSku.val());
    form.append("qty", this.payloadQtySelect.val());
    form.append("sku_qty", this.payloadSkuQty.val());
    form.append("sku_available", this.payloadSkuAvailable.val());

    var settings = {
      url: this.uri,
      method: "POST",
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    $.ajax(settings)
      .done(function (response) {
        const data =
          typeof response === "string" ? JSON.parse(response) : response;

        _this.ajaxStop = true;
        _this.lastApiPincode = _this.pincodeCheckerInput.val();
        _this.tableToObject(data.data);
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.log("Status:", jqXHR.status);

        if (jqXHR.status === 429) {
          // alert("Too many requests. Please try again later.");
          errorConatiner
            .removeClass(_this.pincodeCheckerHideClass)
            .addClass(_this.pincodeCheckerFlexClass);
          responseContainer
            .removeClass(_this.pincodeCheckerFlexClass)
            .addClass(_this.pincodeCheckerHideClass);
          errorMessage.text(
            "Too many requests, please try again after some time",
          );
          _this.pincodeButtonHelper(false);
          _this.pincodeATCButton(false);
        } else {
          errorConatiner
            .removeClass(_this.pincodeCheckerHideClass)
            .addClass(_this.pincodeCheckerFlexClass);
          responseContainer
            .removeClass(_this.pincodeCheckerFlexClass)
            .addClass(_this.pincodeCheckerHideClass);
          errorMessage.text("Something went wrong, please try again later.");
          _this.pincodeButtonHelper(false);
          _this.pincodeATCButton(false);
        }
      });
  }

  /* =========================
      On Variant Change Funciton 
    ========================= */
  changeVariantData() {
    const productRoots = document.querySelectorAll("[data-product-id]");

    productRoots.forEach((root) => {
      root.addEventListener("variantUpdated", (event) => {
        const data = event.detail;
        const availableQty = this.getInventoryQty(data.id);

        this.payLoadVariantId.val(data.id);
        this.payloadSku.val(data.sku);
        this.payloadSkuQty.val(availableQty);
        this.payloadSkuAvailable.val(data.available);

        clearTimeout(this.variantApiTimer);
        this.variantApiTimer = setTimeout(() => {
          this.apiRunHelper();
        }, 300);
      });
    });
  }

  /* =========================
      Quantity Change Function
    ========================= */
  quantityChange() {
    const $iconPlus = $(".icon-plus");
    const $iconMinus = $(".icon-minus");
    const $qtyInput = $(".quantity-input");

    $iconPlus.on("click", () => {
      const qtyValue = $qtyInput.val();
      this.payloadQtySelect.val(qtyValue);
      this.apiRunHelper();
    });

    $iconMinus.on("click", () => {
      const qtyValue = $qtyInput.val();
      this.payloadQtySelect.val(qtyValue);
      this.apiRunHelper();
    });
  }

  /* =========================
      Helper Function Button
    ========================= */
  pincodeButtonHelper(param) {
    const $data = param;
    const $pincodeDummyButton = this.pincodeCheckerDummyButton;
    if ($data === true) {
      return $pincodeDummyButton
        .removeClass(this.pincodeCheckerHideClass)
        .addClass(this.pincodeCheckerFlexClass);
    } else {
      return $pincodeDummyButton
        .addClass(this.pincodeCheckerHideClass)
        .removeClass(this.pincodeCheckerFlexClass);
    }
  }

  /* =========================
      Get Invontory Available Qty Value
    ========================= */
  getInventoryQty(param) {
    const id = param;
    const inventory = JSON.parse(
      document.getElementById("skuInventoryQty").textContent,
    );
    const qty = inventory[id];
    return qty;
  }

  /* =========================
      Bind Input Event Listner
    ========================= */
  bindEventlistner() {
    const _this = this;
    const $pincodeInput = this.pincodeCheckerInput;
    const $errorContainer = this.errorResponseDiv;
    const $responseContainer = this.responsePrintDiv;
    const $errorMessage = this.errorMessageDiv;
    const $flex = this.pincodeCheckerFlexClass;
    const $hide = this.pincodeCheckerHideClass;
    const $shakeAnimationAddClass = this.shakeAnimationAddClass;
    const $reshakeAnimation = "reshake-animation";
    const $shakeAnimation = this.shakeAnimation;

    const $stickyDummyButton = this.stickyDummyButton;

    const showError = (msg) => {
      $errorMessage.text(msg);
      $errorContainer.removeClass($hide).addClass($flex);
      $responseContainer.addClass($hide).removeClass($flex);
      $shakeAnimationAddClass.addClass(_this.shakeAnimation);
      _this.pincodeATCButton(false);
      _this.lastApiPincode = "";
    };

    const hideError = () => {
      $errorContainer.removeClass($flex).addClass($hide);
      $shakeAnimationAddClass.removeClass(_this.shakeAnimation);
      $shakeAnimationAddClass.removeClass('reshake-animation');
      $errorMessage.text("");
    };

    const validateAndRunApi = () => {
      const val = $pincodeInput.val().trim();

      if (val === "") {
        showError("Please enter a pincode to continue");
        return;
      }

      if (val.length < 6) {
        showError("Please enter a valid pincode");
        return;
      }

      // 🔥 CHANGE (only new 6 digit should run API)
      if (val.length === 6 && val !== _this.lastApiPincode) {
        hideError();
        _this.apiRunHelper();
      }
    };

    /* Input event */
    $pincodeInput.on("input", (e) => {
      let value = e.target.value.replace(/\D/g, "");

      if (value.length > 6) {
        value = value.slice(0, 6);
      }

      $pincodeInput.val(value);

      // 🔥 CHANGE
      if (value.length === 6 && value !== _this.lastApiPincode) {
        hideError();
        _this.apiRunHelper();
      }
    });

    /* Enter key */
    $pincodeInput.on("keypress", (e) => {
      if (e.which === 13) {
        e.preventDefault();
        validateAndRunApi();
      }
    });

    /* Blur – NO API */
    $pincodeInput.on("blur", () => {
      const val = $pincodeInput.val().trim();
      if (val === "") {
        showError("Please enter a pincode to continue");
      } else if (val.length < 6) {
        showError("Please enter a valid pincode");
      }
    });

    $pincodeInput.on("focus", () => {
      $pincodeInput.select();
    });

    _this.pincodeCheckerButton.on("click", () => {
      const val = $pincodeInput.val().trim();

      if (val === "") {
        showError("Please enter a pincode to continue");
        return;
      }

      if (val.length < 6) {
        showError("Please enter a valid pincode");
        return;
      }

      // ✅ direct run only if new pincode
      if (val.length === 6) {
        hideError();
        _this.apiRunHelper();
      }
    });

    // $stickyDummyButton.on("click", function (e) {
    //   e.preventDefault();

    //   const $target = $(".pincode_checker_parent");

    //   if ($target.length) {
    //     $("html, body").animate(
    //       {
    //         scrollTop: $target.offset().top - 170, // thoda gap upar se
    //       },
    //       600, // smooth scroll speed
    //     );
    //   }
    // }); 

$stickyDummyButton.on("click", function (e) {
  e.preventDefault();

  const $target = $(".pincode_checker_parent");

  if ($target.length) {
    $("html, body").animate(
      {
        scrollTop: $target.offset().top - 170,
      },
      600,
      function () {
        // 🔥 scroll complete hone ke baad

        // 1️⃣ old shake class remove
        $shakeAnimationAddClass.removeClass($shakeAnimation);

        // 2️⃣ force reflow (important)
        void $shakeAnimationAddClass[0].offsetHeight;

        // 3️⃣ reshake animation add
        $shakeAnimationAddClass.addClass($reshakeAnimation);

        // 4️⃣ animation end pe reshake remove
        $shakeAnimationAddClass.one(
          "animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd",
          function () {
            $(this).removeClass($reshakeAnimation);
            $(this).addClass($shakeAnimation);
          }
        );
      }
    );
  }
});


  


    /* ❌ e, +, -, arrow up/down prevent */
$pincodeInput.on("keydown", function (e) {
  // disallowed keys
  const blockedKeys = [
    "e", "E", "+", "-", ".", 
    "ArrowUp", "ArrowDown"
  ];

  if (blockedKeys.includes(e.key)) {
    e.preventDefault();
    return false;
  }
});

/* ❌ Mouse wheel number change prevent */
$pincodeInput.on("wheel", function (e) {
  e.preventDefault();
});

/* ❌ Extra safety: number input spinner disable */
$pincodeInput.on("focus", function () {
  this.addEventListener(
    "wheel",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );
});
  }

  /* =========================
     Canvert Table Response In Object 
   ========================= */
  tableToObject(param) {
    const $table = $(param);
    const result = {};

    const pincodeText = $table.find(".dt-title span").first().text().trim();
    if (pincodeText) result.pincode = pincodeText;

    const deliveryDate = $table.find(".date").text().trim();
    if (deliveryDate) result.delivery_by = deliveryDate;

    const notServiceableText = $table.find("th strong").text().trim();
    if (notServiceableText) {
      result.message = notServiceableText;
      result.serviceable = false;
    } else {
      result.serviceable = true;
    }

    return this.displayResponse(result);
  }

  displayResponse(param) {
    const data = param;
    localStorage.setItem("pincode_checker", data.pincode);

    const responseContainer = this.responsePrintDiv;
    const shippingRespone = this.responseShippingDiv;
    const shippingDate = this.responseDateDiv;
    const errorConatiner = this.errorResponseDiv;
    const errorMessage = this.errorMessageDiv;
    const formatDate = this.formatDeliveryDate(data.delivery_by);

    if (data.serviceable === true) {
      errorConatiner
        .addClass(this.pincodeCheckerHideClass)
        .removeClass(this.pincodeCheckerFlexClass);
      responseContainer
        .addClass(this.pincodeCheckerFlexClass)
        .removeClass(this.pincodeCheckerHideClass);
      shippingRespone.text("Free Shipping");
      shippingDate.text(formatDate);
      this.pincodeATCButton(true);
      this.pincodeButtonHelper(false);
    } else {
      errorConatiner
        .removeClass(this.pincodeCheckerHideClass)
        .addClass(this.pincodeCheckerFlexClass);
      responseContainer
        .removeClass(this.pincodeCheckerFlexClass)
        .addClass(this.pincodeCheckerHideClass);
      errorMessage.text(data.message);
      this.pincodeATCButton(false);
      this.pincodeButtonHelper(false);
    }
  }

  /* =========================
      ATC/Buynow Button Enable Funciton
    ========================= */
  // pincodeATCButton(param) {
  //   const $data = param;
  //   const $atcDummyButtonContainer = this.dummyButtonContainer;
  //   const $atcRealButton = this.realAtcButton;
  //   const $buyRealButton = this.realBuyButton;
  //   const $stickyDummyButton = this.stickyDummyButton;
  //   const $stickyRealButton = this.stickyRealButton;
  //   const $magic = this.magicChckoutButton;
  //   const dummyRelatedButton = document.querySelectorAll('button.pdp_btn.dummy_btn2.custom_addtocart__button');
  //   const realRelatedButton = document.querySelectorAll('button.but_it_with.pdp_btn');

  //   if ($data === true) {
  //     $atcDummyButtonContainer
  //       .addClass(this.pincodeCheckerHideClass)
  //       .removeClass(this.pincodeCheckerFlexClass);
  //     $atcRealButton
  //       .addClass(this.pincodeCheckerFlexClass)
  //       .removeClass(this.pincodeCheckerHideClass);
  //     $buyRealButton
  //       .addClass(this.pincodeCheckerFlexClass)
  //       .removeClass(this.pincodeCheckerHideClass);
  //     $stickyDummyButton
  //       .addClass(this.pincodeCheckerHideClass)
  //       .removeClass(this.pincodeCheckerBlockClass);
  //     $stickyRealButton
  //       .addClass(this.pincodeCheckerBlockClass)
  //       .removeClass(this.pincodeCheckerHideClass);
  //     $magic.attr("onclick", "onBuyNowClickMagic(event)");
  //   } else {
  //     $atcDummyButtonContainer
  //       .addClass(this.pincodeCheckerFlexClass)
  //       .removeClass(this.pincodeCheckerHideClass);
  //     $atcRealButton
  //       .addClass(this.pincodeCheckerHideClass)
  //       .removeClass(this.pincodeCheckerFlexClass);
  //     $buyRealButton
  //       .addClass(this.pincodeCheckerHideClass)
  //       .removeClass(this.pincodeCheckerFlexClass);
  //     $stickyDummyButton
  //       .addClass(this.pincodeCheckerBlockClass)
  //       .removeClass(this.pincodeCheckerHideClass);
  //     $stickyRealButton
  //       .addClass(this.pincodeCheckerHideClass)
  //       .removeClass(this.pincodeCheckerBlockClass);
  //     $magic.removeAttr("onclick");
  //   }
  // }

  pincodeATCButton(param) {
    const $data = param;

    const $atcDummyButtonContainer = this.dummyButtonContainer;
    const $atcRealButton = this.realAtcButton;
    const $buyRealButton = this.realBuyButton;
    const $stickyDummyButton = this.stickyDummyButton;
    const $stickyRealButton = this.stickyRealButton;
    const $magic = this.magicChckoutButton;

    // Related product buttons
    const dummyRelatedButtons = document.querySelectorAll(
        'button.pdp_btn.dummy_btn2.custom_addtocart__button'
    );

    const realRelatedButtons = document.querySelectorAll(
        'button.but_it_with.pdp_btn'
    );

    if ($data === true) {

        // =========================
        // MAIN PDP BUTTONS
        // =========================

        $atcDummyButtonContainer
            .addClass(this.pincodeCheckerHideClass)
            .removeClass(this.pincodeCheckerFlexClass);

        $atcRealButton
            .addClass(this.pincodeCheckerFlexClass)
            .removeClass(this.pincodeCheckerHideClass);

        $buyRealButton
            .addClass(this.pincodeCheckerFlexClass)
            .removeClass(this.pincodeCheckerHideClass);

        $stickyDummyButton
            .addClass(this.pincodeCheckerHideClass)
            .removeClass(this.pincodeCheckerBlockClass);

        $stickyRealButton
            .addClass(this.pincodeCheckerBlockClass)
            .removeClass(this.pincodeCheckerHideClass);

        $magic.attr("onclick", "onBuyNowClickMagic(event)");


        // =========================
        // RELATED PRODUCT BUTTONS
        // TRUE:
        // Dummy = HIDE
        // Real  = BLOCK
        // =========================

        dummyRelatedButtons.forEach((button) => {
            button.classList.add(this.pincodeCheckerHideClass);
            button.classList.remove(this.pincodeCheckerBlockClass);
        });

        realRelatedButtons.forEach((button) => {
            button.classList.add(this.pincodeCheckerBlockClass);
            button.classList.remove(this.pincodeCheckerHideClass);
        });

    } else {

        // =========================
        // MAIN PDP BUTTONS
        // =========================

        $atcDummyButtonContainer
            .addClass(this.pincodeCheckerFlexClass)
            .removeClass(this.pincodeCheckerHideClass);

        $atcRealButton
            .addClass(this.pincodeCheckerHideClass)
            .removeClass(this.pincodeCheckerFlexClass);

        $buyRealButton
            .addClass(this.pincodeCheckerHideClass)
            .removeClass(this.pincodeCheckerFlexClass);

        $stickyDummyButton
            .addClass(this.pincodeCheckerBlockClass)
            .removeClass(this.pincodeCheckerHideClass);

        $stickyRealButton
            .addClass(this.pincodeCheckerHideClass)
            .removeClass(this.pincodeCheckerBlockClass);

        $magic.removeAttr("onclick");


        // =========================
        // RELATED PRODUCT BUTTONS
        // FALSE:
        // Dummy = BLOCK
        // Real  = HIDE
        // =========================

        dummyRelatedButtons.forEach((button) => {
            button.classList.add(this.pincodeCheckerBlockClass);
            button.classList.remove(this.pincodeCheckerHideClass);
        });

        realRelatedButtons.forEach((button) => {
            button.classList.add(this.pincodeCheckerHideClass);
            button.classList.remove(this.pincodeCheckerBlockClass);
        });
    }
}

  /* =========================
    Formate Response Delivery Data Function
    ========================= */
  // formatDeliveryDate(rawDate) {
  //   if (!rawDate) return "";

  //   const [datePart, monthPartYear] = rawDate.split(" ");
  //   const dateNumber = datePart.replace(/(st|nd|rd|th)/, "");
  //   const monthName = monthPartYear.replace(",", "");

  //   const fullDate = new Date(`${dateNumber} ${monthName} 2025`);
  //   if (isNaN(fullDate)) return rawDate;

  //   const days = [
  //     "Sunday",
  //     "Monday",
  //     "Tuesday",
  //     "Wednesday",
  //     "Thursday",
  //     "Friday",
  //     "Saturday",
  //   ];

  //   const dayName = days[fullDate.getDay()];
  //   const originalDate = rawDate.split(" ")[0];

  //   return `${dayName}, ${originalDate} ${monthName}`;
  // }

  formatDeliveryDate(dateStringWithSuffix) {
    // console.log("dateStringWithSuffix" , dateStringWithSuffix);
    if (!dateStringWithSuffix) return "";

    const cleanDate = dateStringWithSuffix.replace(/(st|nd|rd|th)/g, '');

    const dateObject = new Date(cleanDate);

    if (isNaN(dateObject.getTime())) {
      return "Invalid Date";
    }

    const weekdayName = dateObject.toLocaleDateString('en-US', {
      weekday: 'long'
    });

    const match = dateStringWithSuffix.match(/^(\d+(?:st|nd|rd|th))\s+([A-Za-z]+)/);

    if (!match) return "Invalid Date";

    const dayWithSuffix = match[1];
    const monthShort = match[2].slice(0, 3);
  
    return `${weekdayName}, ${dayWithSuffix} ${monthShort}`;
  }

}

$(document).ready(function () {
  new PincodeChecker();
});
